import { useEffect, useState } from 'react';
// Cross-feature: 결과 라이더 이름 맵 조회 — partner/supplierFee 기능과 공유
import { supplierFeeApi } from '@/features/partner/supplierFee/riderToPartner/api/supplierFeeApi';
import { promoMissionApi, RiderResultDto } from '../api/promoMissionApi';
import { Mission } from '../types/promotion.types';

interface UsePromotionModalProps {
    today: string;
    ridersLoaded: boolean;
    ridersLoading: boolean;
    fetchRiders: () => Promise<void>;
}

export function usePromotionModal({
                                      today,
                                      ridersLoaded,
                                      ridersLoading,
                                      fetchRiders,
                                  }: UsePromotionModalProps) {
    const [selectedMission, setSelectedMission] = useState<Mission | null>(null);
    const [riderResults, setRiderResults] = useState<RiderResultDto[] | null>(null);
    const [riderResultsLoading, setRiderResultsLoading] = useState(false);
    const [expandedRiderIds, setExpandedRiderIds] = useState<Set<string>>(new Set());
    const [resultRiderMap, setResultRiderMap] = useState<Map<string, string>>(new Map());

    // 모달 열릴 때 스크롤 잠금
    useEffect(() => {
        if (selectedMission) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [selectedMission]);

    // 종료된 미션 모달 열릴 때 라이더별 달성 결과 조회
    useEffect(() => {
        if (!selectedMission || selectedMission.endDate >= today) {
            setRiderResults(null);
            setExpandedRiderIds(new Set());
            return;
        }

        // 결과 조회 시 form용 라이더 목록도 미리 로딩 (수정 전환 대비)
        if (!ridersLoaded && !ridersLoading) {
            fetchRiders();
        }

        setRiderResults(null);
        setRiderResultsLoading(true);

        // 결과용 라이더 이름 맵 — 미션의 suppId 사용 (본사 계정도 해당 협력사 라이더 조회 가능)
        const missionSuppId = selectedMission.suppId;
        if (missionSuppId) {
            supplierFeeApi
                .getAllRiderList(missionSuppId)
                .then((res) => {
                    const map = new Map<string, string>();
                    (res.riders || []).forEach((r) => map.set(r.riderId, r.riderName));
                    setResultRiderMap(map);
                })
                .catch(() => {
                    /* 이름 조회 실패 시 riderId만 표시 */
                });
        }

        promoMissionApi
            .getMissionRiderResults(selectedMission.seqNo)
            .then((res) => setRiderResults(res.riderResults))
            .catch(() => setRiderResults([]))
            .finally(() => setRiderResultsLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMission?.seqNo]);

    return {
        selectedMission,
        setSelectedMission,
        riderResults,
        riderResultsLoading,
        expandedRiderIds,
        setExpandedRiderIds,
        resultRiderMap,
    };
}
